module.exports = __webpack_public_path__ + "static/media/chefs_hat_icon.dac53b5f.png";